import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  getColor,
  Icons,
  InputField,
  Modal,
  Typography,
  useToast,
} from "fds";
import "./index.scss";
import useLoginStore from "../../redux/dispatcher/useLoginStore";
import { nanoid } from "@reduxjs/toolkit";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import utilsCommon from "../../shared/utils/common";
import {
  getRedirectUrl,
  getUserInfoFromLocalStorage,
  removeRedirectUrl,
} from "../../shared/utils/auth";
import { LoginDto } from "../../types/auth";

interface GoogleOTPLoginModalProps {
  open: boolean;
  isAdmin?: boolean;
  requestId: string;
  isMobile?: boolean;
  onClose: () => void;
}
const GoogleOTPLoginModal: React.FC<GoogleOTPLoginModalProps> = ({
  open,
  isAdmin,
  requestId,
  isMobile,
  onClose,
}) => {
  const user = getUserInfoFromLocalStorage() as string | "";
  const loginDto: LoginDto = JSON.parse(user);
  const toast = useToast();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [otp, changeOtp] = useState("");
  const { loginGoogleOtp } = useLoginStore();
  const handleLoginOTPWIthGoogle = async () => {
    let resp = await loginGoogleOtp({ userId: requestId, otp: otp });
    if (resp.payload) {
      let redirectUrl = getRedirectUrl();
      if (redirectUrl && !redirectUrl.includes("/login")) {
        removeRedirectUrl();
        try {
          const url = new URL(redirectUrl);
          navigate(url.pathname);
        } catch (err) {
          window.location.replace(redirectUrl);
        }
      } else {
        const defaultTenancy = resp.payload?.defaultTenancy ?? "My Space";
        const featureAccessType =
          resp.payload?.ecoSystemLicenseStats?.featureAccessType ?? "";
        navigate( // navigate-skip: login flow, OCI handled manually with defaultTenancy
          isAdmin
            ? `${process.env.PUBLIC_URL}/admin/home`
            : featureAccessType === "LITE"
            ? `${process.env.PUBLIC_URL}/myInbox/received`
            : window.eco.serviceType === "OCI" && defaultTenancy
            ? `${process.env.PUBLIC_URL}/${defaultTenancy}/home`
            : `${process.env.PUBLIC_URL}/home`
        );
      }
    } else {
      toast.toastMsg(nanoid(), t("login.googleOTP.invalidOTP"), "error");
    }
  };
  return (
    <Modal
      open={open}
      onClose={onClose}
      isMobile={isMobile}
      isExit={!isMobile}
      title={t("login.googleOTP.login")}
      subTitle={
        <Typography
          type="body4_rg"
          exactColor={getColor("COLOR_TEXT_SECONDARY")}
          whiteSpace="break-spaces"
        >
          {t("login.googleOTP.loginDesc")}
        </Typography>
      }
      width={540}
      body={
        <Box direction="column" justifyContent="center" width={"100%"}>
          <InputField
            size="md"
            value={otp}
            maxLength={6}
            onChange={(e) => changeOtp(e.target.value)}
            placeholder={t("login.googleOTP.codePlaceholder")}
            label={t("login.googleOTP.code")}
          />
        </Box>
      }
      footer={
        isMobile ? (
          <Box width="100%">
            <Box onClick={onClose}>
              <Typography textAlign="center" type="body1_md">
                {t("login.googleOTP.loginDifferentID")}
              </Typography>
            </Box>
            <Box>
              <Typography
                textAlign="center"
                type="body1_md"
                exactColor={getColor(
                  otp
                    ? "COLOR_TEXT_BRAND"
                    : "COLOR_TEXT_INTERACTIVE_BRAND_DISABLED"
                )}
                onClick={handleLoginOTPWIthGoogle}
              >
                {t("common.confirm")}
              </Typography>
            </Box>
          </Box>
        ) : (
          <Box
            width={"calc(100% + 16px)"}
            justifyContent="space-between"
            alignItems="center"
          >
            <span style={{ marginInlineStart: "-8px" }}>
              <Button
                btnStyle="link"
                leadingIcon={<Icons variant="line" label="exit" />}
                label={t("login.googleOTP.loginDifferentID")}
                onClick={onClose}
              />
            </span>

            <Button
              btnStyle="fill"
              state={otp ? "default" : "disable"}
              label={t("login.title")}
              onClick={handleLoginOTPWIthGoogle}
            />
          </Box>
        )
      }
    />
  );
};
export default GoogleOTPLoginModal;
